// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2741":"5a19e689cbd03c41","6885":"361aad977fcce83a","8428":"fefcd7f7577cbb92"}[chunkId] + ".js";
};